import { Patient } from '@dreryk/egabinet-patient-frontend-api';

import { AddCircleIcon, Link, LinkSize } from '@dreryk/react-components';

import { patientConsentsAndAuthorizationsTranslationKeys } from '../../../translations';
import { MedicalDataAccessAuthorizationOpenFormAction } from '../MedicalDataAccessAuthorizationModal/MedicalDataAccessAuthorizationOpenFormAction';

import { useCreateMedicalDataAccessAuthorization } from './CreateMedicalDataAccessAuthorizationAction.hooks';

type CreateMedicalDataAccessAuthorizationActionProps = {
   readonly patientId: Patient['id'];
   readonly withIcon?: boolean;
};

const CreateMedicalDataAccessAuthorizationAction = (
   props: CreateMedicalDataAccessAuthorizationActionProps
): JSX.Element => {
   const { executeAsync: createMedicalDataAccessAuthorization } = useCreateMedicalDataAccessAuthorization(
      props.patientId
   );

   return (
      <MedicalDataAccessAuthorizationOpenFormAction
         initialValues={null}
         onSubmit={createMedicalDataAccessAuthorization}
         render={(openModal) => (
            <Link
               testId='addAuthorization'
               label={patientConsentsAndAuthorizationsTranslationKeys.authorizations.addAuthorization}
               onClick={openModal}
               icon={props.withIcon ? <AddCircleIcon /> : null}
               size={LinkSize.NORMAL}
            />
         )}
         modalTitle={patientConsentsAndAuthorizationsTranslationKeys.authorizations.additionAuthorization}
      />
   );
};

export { CreateMedicalDataAccessAuthorizationAction };
